module.exports = __webpack_public_path__ + "static/bg-8616c4019aac271b45af419bb9eb2259.png";